import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { DataService } from './data.service';
import { NotificationModule } from '../notification/notification.module';
import { DownloadService } from './download.service';
import { UploadProgressBarComponent } from './upload-progress-bar/upload-progress-bar.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    UploadProgressBarComponent
  ],
  imports: [
    CommonModule,
    NotificationModule,
    HttpClientModule,
    MatProgressBarModule
  ],
  providers: [
    DataService,
    DownloadService
  ],
  exports: [
    UploadProgressBarComponent
  ]
})
export class DataModule { }
